import trainingModules2025 from './trainingModules2025.json';

export const runtimeDocuments = {
  'training-modules-2025': trainingModules2025,
};

export default runtimeDocuments;
